import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { validCrmSlugs } from "../utils/crmRoutes";

/**
 * Hook that returns the current CRM base path from the URL.
 * Use this instead of hardcoding '/realestate' in navigate() or href.
 * 
 * Usage:
 *   const crmPath = useCrmPath(); // e.g., '/wholesale'
 *   navigate(`${crmPath}/deals`);
 */
export function useCrmPath() {
  const location = useLocation();
  return useMemo(() => {
    const firstSegment = location.pathname.split('/')[1];
    if (validCrmSlugs.includes(firstSegment)) {
      return `/${firstSegment}`;
    }
    return '/realestate';
  }, [location.pathname]);
}

export default useCrmPath;
